import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(3 50)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M40.618-1l-3 6h-3.689a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0127 11a6.977 6.977 0 01-4.856-1.958A6.985 6.985 0 0120.1 5.185h0l-3.177-.143A6.981 6.981 0 0114.95 8.95 6.978 6.978 0 0110 11a6.977 6.977 0 01-4.856-1.958A6.985 6.985 0 013.096 5.16h0L.956 5a1.994 1.994 0 01-1.37-.586A1.994 1.994 0 01-1 3h0v-4h41.618z",
						stroke: "#0D0E10",
						strokeWidth: 2
					}),
					/* @__PURE__ */ _jsx("circle", {
						fill: "#0D0E10",
						cx: 10.63,
						cy: 5,
						r: 2
					}),
					/* @__PURE__ */ _jsx("circle", {
						fill: "#0D0E10",
						cx: 27.63,
						cy: 5,
						r: 2
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.557 35.959l-.22.12-2.9 1.66a.47.47 0 00-.24.32c-.17.69-.36 1.38-.55 2.08l-.21.8a.75.75 0 11-1.44-.35l.39-1.46a1.67 1.67 0 000-.19l-1 .59-1.21.7a.75.75 0 01-1.05-.25.74.74 0 01.31-1l2.18-1.26.2-.11-1.14-.31-.71-.19a.73.73 0 01-.54-.79.71.71 0 01.64-.65.83.83 0 01.35 0c1 .25 1.95.5 2.92.79a.63.63 0 00.58-.09l2.77-1.6.12-.07-.93-.54c-.76-.44-1.52-.88-2.29-1.31a.31.31 0 00-.23 0l-3 .8a.74.74 0 11-.38-1.43l1.55-.42.14-.05-1.36-.78-.94-.54a.742.742 0 01.75-1.28l2.19 1.26.2.1c-.08-.28-.14-.53-.21-.78-.07-.25-.2-.73-.29-1.09a.72.72 0 01.54-.87.73.73 0 01.89.49c.28 1 .56 2.07.83 3.11a.41.41 0 00.22.3l2.9 1.66.19.11v-.19-3.34a.51.51 0 00-.17-.41c-.44-.41-.87-.85-1.3-1.28l-.94-.94a.73.73 0 01.34-1.22.71.71 0 01.75.21l1.16 1.16a.71.71 0 01.1.14h.06v-2.75a.744.744 0 011.48-.15c.005.06.005.12 0 .18v2.56l.66-.68.53-.54a.76.76 0 011.07 0 .75.75 0 010 1.06c-.74.75-1.49 1.49-2.23 2.23a.21.21 0 00-.07.14v3.75l1.39-.8 1.57-.91a.42.42 0 00.29-.38c.06-.323.143-.64.25-.95.18-.69.36-1.38.56-2.07a.74.74 0 011.43.39l-.46 1.69a1.21 1.21 0 010 .14l.37-.2 2-1.18a.753.753 0 11.76 1.3l-1.84 1.06-.48.28 1.41.38.36.1a.74.74 0 01.47.9.73.73 0 01-.86.52c-1-.25-2-.51-2.93-.78a.57.57 0 00-.51.06c-1 .56-1.91 1.11-2.87 1.66l-.16.09.16.11 2.79 1.61a.51.51 0 00.45.05c.38-.13.77-.22 1.15-.32l1.81-.48a.741.741 0 11.39 1.43l-1.78.52.18.11 2.26 1.24a.74.74 0 01-.17 1.36.74.74 0 01-.61-.1l-2.12-1.22-.17-.09.31 1.17c0 .17.09.34.14.51a.75.75 0 11-1.44.38l-.81-3a.18.18 0 00-.07-.1l-3.19-1.86a.86.86 0 000 .15v3.42c0 .15.09.19.16.26l1.6 1.6.53.53a.74.74 0 11-1 1c-.36-.36-.72-.71-1.07-1.07l-.17-.15V44.399a.74.74 0 11-1.47 0v-2.7l-.12.1c-.41.41-.81.82-1.23 1.22a.74.74 0 01-1.24-.28.7.7 0 01.14-.75c.73-.73 1.46-1.48 2.21-2.19a.61.61 0 00.21-.51v-3.13l-.04-.2z",
				fill: "#1D1D1B",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("rect", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				x: 1,
				y: 21,
				width: 62,
				height: 28,
				rx: 2
			})
		]
	})
});
export default SvgFt;
